import { css } from 'styled-components';

const radius = css`
  border-radius: 3px;
`;

export default radius;



// WEBPACK FOOTER //
// ./src/theme/styles.js